import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProvincesRoutingModule } from './provinces-routing.module';
import { ProvincesListComponent } from './provinces-list/provinces-list.component';
import { ProvincesDetailComponent } from './provinces-detail/provinces-detail.component';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';


@NgModule({
  declarations: [ProvincesListComponent, ProvincesDetailComponent],
  imports: [
    CommonModule,
    ProvincesRoutingModule,
    CommonModule,
    FormsModule,
    HttpClientModule,
    ButtonModule,
    InputTextModule,
    TableModule,
    CardModule,
    FontAwesomeModule,
    ConfirmDialogModule,
    DropdownModule
  ],
  exports:[
    ProvincesListComponent,
    ProvincesDetailComponent
  ]
})
export class ProvincesModule { }
